/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Faq_Q2Inputs */

const en_to_yaml_faq_q2 = /** @type {(inputs: To_Yaml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Does YAML support all JSON data types?`)
};

const ko_to_yaml_faq_q2 = /** @type {(inputs: To_Yaml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML은 모든 JSON 데이터 타입을 지원하나요?`)
};

const ja_to_yaml_faq_q2 = /** @type {(inputs: To_Yaml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAMLはすべてのJSONデータ型をサポートしていますか？`)
};

/**
* | output |
* | --- |
* | "Does YAML support all JSON data types?" |
*
* @param {To_Yaml_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_faq_q2 = /** @type {((inputs?: To_Yaml_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_faq_q2(inputs)
	if (locale === "ko") return ko_to_yaml_faq_q2(inputs)
	return ja_to_yaml_faq_q2(inputs)
});